import React from 'react'
import ReactDOM from 'react-dom'
import App from '@components/App'
import dotenv from 'dotenv'
import * as serviceWorker from './serviceWorker'
import './index.css'

dotenv.config()
ReactDOM.render(<App />, document.getElementById('root'))
serviceWorker.unregister()
